import { forwardRef, type HTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const cluster = cva('flex flex-row flex-wrap', {
  variants: {
    gap: {
      xs: 'gap-1',
      sm: 'gap-2',
      md: 'gap-3',
      lg: 'gap-4',
      xl: 'gap-6',
    },
    align: {
      start: 'items-start',
      center: 'items-center',
      end: 'items-end',
      baseline: 'items-baseline',
    },
    justify: {
      start: 'justify-start',
      between: 'justify-between',
      end: 'justify-end',
      center: 'justify-center',
    },
  },
  defaultVariants: { gap: 'md', align: 'center', justify: 'start' },
});

export interface ClusterProps
  extends HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof cluster> {}

export const Cluster = forwardRef<HTMLDivElement, ClusterProps>(function Cluster(
  { gap, align, justify, className, ...rest },
  ref,
) {
  return (
    <div ref={ref} className={cn(cluster({ gap, align, justify }), className)} {...rest} />
  );
});
